import { useEffect } from 'react';
import { RUM } from 'src/services/rum';
import { logger } from 'src/services';

export const useTrackPerfMetrics = () => {
  useEffect(() => {
    const rumInstance = RUM.getInstance();
    if (!rumInstance) {
      return logger.error('useTrackPerfMetrics: RUM is not initialized yet');
    }

    if ((document as any).wasDiscarded) {
      rumInstance.addAction('Perf: Page was discarded by browser', {
        lifecycleState: 'discarded',
      });
    }

    const handleFreeze = () => {
      rumInstance.addAction('Perf: Page Freezing', {
        lifecycleState: 'frozen',
      });
    };

    const handleResume = () => {
      rumInstance.addAction('Perf: Page Resumed', {
        lifecycleState: 'resumed',
      });
    };

    document.addEventListener('freeze', handleFreeze);
    document.addEventListener('resume', handleResume);

    return () => {
      document.removeEventListener('freeze', handleFreeze);
      document.removeEventListener('resume', handleResume);
    };
  }, []);
};
